import { useState } from "react";
import { st } from "../../styles.js";
import { BuzerIcon } from "../../BuzerIcons";
import { Modal } from "./Modal";
import { hasInstallPrompt, promptInstall } from "../../lib/pwa";

// Step-by-step "add to home screen" guide for existing users (onboarding is skipped
// for them). Uses the native install prompt when the browser offers one (Android /
// desktop Chrome), otherwise shows manual steps for the detected platform.
export function InstallGuide({ onClose }) {
  const ua = (typeof navigator !== "undefined" && navigator.userAgent) || "";
  const isIOS = /iphone|ipad|ipod/i.test(ua)
    || (typeof navigator !== "undefined" && navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const isAndroid = /android/i.test(ua);
  const [canPrompt, setCanPrompt] = useState(hasInstallPrompt());
  const [busy, setBusy] = useState(false);
  async function nativeInstall() {
    if (!hasInstallPrompt()) { setCanPrompt(false); return; }
    setBusy(true);
    try {
      const outcome = await promptInstall();
      if (outcome === "accepted") { onClose(); return; }
    } catch (e) { /* fall back to manual steps */ }
    setBusy(false); setCanPrompt(false);
  }
  const steps = isIOS
    ? ["Otvor Buzerlístok v prehliadači Safari.",
       "Dole klikni na ikonu Zdieľať (štvorček so šípkou nahor).",
       "Vyber „Na plochu / Add to Home Screen“.",
       "Potvrď „Pridať“ — Buzerlístok pribudne na plochu ako appka."]
    : isAndroid
    ? ["Vpravo hore klikni na menu prehliadača (⋮).",
       "Vyber „Pridať na plochu“ alebo „Inštalovať aplikáciu“.",
       "Potvrď — Buzerlístok pribudne na plochu ako appka."]
    : ["V adresnom riadku klikni na ikonu inštalácie (vpravo).",
       "Alebo otvor menu prehliadača → „Inštalovať Buzerlístok“.",
       "Appka sa otvorí vo vlastnom okne."];
  return (
    <Modal title="Pridať appku na plochu" icon="add" onClose={onClose}>
      <div style={st.taskDesc}>Maj Buzerlístok poruke ako na telefóne — otvorí sa na celú obrazovku a môžeš si zapnúť upozornenia.</div>
      {canPrompt && (
        <button onClick={nativeInstall} disabled={busy}
          style={{ ...st.primaryBtn, width: "100%", margin: "14px 0 4px", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
          <BuzerIcon name="phone" size={18} color="currentColor" />{busy ? "…" : "Inštalovať appku"}</button>
      )}
      <ol style={{ margin: "12px 0 4px", paddingLeft: 22, lineHeight: 1.7, fontSize: 14, color: "var(--text2)" }}>
        {steps.map((t, i) => <li key={i} style={{ marginBottom: 6 }}>{t}</li>)}
      </ol>
      <div style={{ ...st.infoNote, marginTop: 10, display: "inline-flex", alignItems: "center", gap: 6 }}><BuzerIcon name="bell" size={14} color="var(--text2)" /> Upozornenia potom zapneš v <strong>Účet → Upozornenia</strong>.</div>
    </Modal>
  );
}
